import { ENVIRONMENT, ENVIRONMENT_TYPE } from './common';

export const KLU_ENVIRONMENT = {
  [ENVIRONMENT_TYPE.PRODUCTION]: {
    signup: 'https://corporate.klu.mx/#/home/createcredentialsOB/',
    login: 'https://corporate.klu.mx/#/home/',
  },
  [ENVIRONMENT_TYPE.STAGING]: {
    signup: 'https://corporate.qa-klu.mx/#/home/createcredentialsOB',
    login: 'https://corporate.qa-klu.mx/#/home/',
  },
  [ENVIRONMENT_TYPE.PREPRODUCTION]: {
    signup: 'https://corporate.qa-klu.mx/#/home/createcredentialsOB/',
    login: 'https://corporate.qa-klu.mx/#/home/',
  },
};

export const KLU_URL = {
  signup: window.KLU_URL?.signup || KLU_ENVIRONMENT[ENVIRONMENT]?.signup || KLU_ENVIRONMENT[ENVIRONMENT_TYPE.PRODUCTION].signup,
  login: window.KLU_URL?.login || KLU_ENVIRONMENT[ENVIRONMENT]?.login || KLU_ENVIRONMENT[ENVIRONMENT_TYPE.PRODUCTION].login,
};
